module.exports = __webpack_public_path__ + "img/2.aea6f1dd.png";